<template>
  <div ref="mainContainer" class="d-flex flex-column" style="height: 100%;">
    <div class="row f-row justify-content-center" style="height: 100%;">
      <transition name="fadeCharts">
        <div class="col text-center" style="height: 100%;">
          <div class="h-100 d-flex flex-column">
            <!-- Row: title and resize button -->
            <div
              v-if="!verySmall"
              class="row f-row mb-2 markets-chart-title d-flex align-items-center"
            >
              <div
                class="col"
                :class="slotUsed ? 'col-6' : 'col-12 left_padd'"
                style="font-size: 1rem"
              >
                Daily
                {{ userSelections["isCandles"] ? "candles" : "line chart" }} for
                &nbsp;
                <span style="color: var(--textactive)">
                  {{ commodityStringLong }}
                </span>
              </div>
              <slot name="spot"></slot>
            </div>
            <!-- Row: controls and labels -->
            <div class="row f-row controls align-items-center">
              <div class="col col-5">
                <div class="row f-row">
                  <div
                    v-if="!verySmall"
                    class="col col-auto text-right curve_line controls_date-r"
                    style="padding-left: 60px;"
                  >
                    <span
                      class="inh"
                      style="padding-right: 3px; padding-left: 12px;"
                      >Date range:</span
                    >
                  </div>
                  <div
                    :class="verySmall ? 'col-11' : 'col-5'"
                    class="col row-middle-titles text-center"
                  >
                    <IntervalsIndepComponent
                      :initPickedDateInterval="
                        userSelections['historyInterval']
                      "
                      @eventOnChangeInterval="onChangeHistoryInterval"
                      :threeYears="false"
                      :fiveYears="false"
                      :tenYears="false"
                      :twentyYears="false"
                    />
                  </div>
                </div>
              </div>
              <div class="col col-7">
                <div class="row f-row align-items-center">
                  <div class="col col-auto mr-2 curve_line">
                    <span style="padding-left: 5px;">
                      <i class="fa fa-minus" style="color:var(--expo)"></i>
                      <span class="inline-ul ml-1"
                        >Min/Max range for
                        <span style="color: var(--textactive);">
                          {{ userSelections["historyInterval"] }}
                        </span>
                      </span>
                    </span>
                  </div>
                  <div class="col col-auto mr-2 curve_line">
                    <i class="fa fa-minus" style="color:var(--fwd)"></i>
                    <span class="inline-ul ml-1">Current prices</span>
                  </div>
                  <div
                    v-if="!verySmall"
                    class="col col-auto results-table-headers mt-1"
                    style="height:100%; padding: 0; top:-4px;"
                  >
                    <label
                      :for="'scale_button'"
                      class="toggle__button_g"
                      style="height: 100%"
                      :class="{ actives: userSelections['showComparison'] }"
                    >
                      <input
                        type="checkbox"
                        @click="onUserShowComparison"
                        :id="'scale_button'"
                      />
                      <span class="toggle__switch_g"></span>
                    </label>
                  </div>
                  <div
                    v-if="!verySmall"
                    class="col col-auto mr-2 curve_line ml-1"
                  >
                    Compare
                    {{ userSelections["showComparison"] ? "On" : "Off" }}
                  </div>
                  <div
                    class="col col-auto mr-2 curve_line"
                    v-show="userSelections['showComparison']"
                  >
                    <i class="fa fa-minus" style="color:var(--hedge)"></i>
                    <span class="inline-ul ml-1">Prices for:</span>
                  </div>
                  <div
                    class="col col-auto mr-2 curve_line controls_calendar"
                    v-bind:class="[
                      allData['highlight'] ? 'bdr_fwd_highlight' : '',
                    ]"
                    v-show="userSelections['showComparison']"
                  >
                    <Calendar
                      v-model="userSelections['selectedDate']"
                      dateFormat="M dd, yy"
                      placeholder="mmm dd, yyyy"
                      @date-select="onUserSelectedDate"
                    />
                  </div>
                  <div
                    class="col col-4 row-middle-titles controls_intervals"
                    style="z-index: 1"
                    v-show="userSelections['showComparison']"
                  >
                    <IntervalsIndepComponent
                      :initPickedDateInterval="userSelections['dateInterval']"
                      @eventOnChangeInterval="onChangeDateInterval"
                      :threeYears="false"
                      :fiveYears="false"
                      :tenYears="false"
                      :twentyYears="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- Row: Chart -->
            <div
              class="row f-row curve_analysis_chart_height"
              :class="{
                'curve_analysis_chart_height--compact': isTableCompact,
              }"
              style="position: relative !important;"
            >
              <div class="row f-row ta_legend_small">
                <div
                  class="col col-auto curve_line text-left"
                  style="padding-left: 55px;"
                >
                  <input
                    type="button"
                    :id="'linesOrCandles'"
                    @click="onUserCandlesLineSelect"
                  />
                  <label style="cursor: pointer;" :for="'linesOrCandles'">
                    <div
                      class="triangle-topleft"
                      v-if="userSelections['isCandles']"
                    ></div>
                    <i class="fa fa-minus" style="color:var(--expo)" v-else></i>
                  </label>
                  <span class="inline-ul ml-1">Up/Down</span>
                </div>
              </div>
              <div
                class="col col-5"
                style="height:100%; width:100%; position: relative;"
              >
                <div
                  v-if="loading['historical'] || loading['historicalProcess']"
                  class="text-center"
                  style="width: 100%; top: calc(50% - 8px)!important; position: absolute;"
                >
                  <QSLoading
                    :isLoading="
                      loading['historical'] || loading['historicalProcess']
                    "
                    :size="40"
                    :colorTheme="colorTheme"
                  />
                </div>
                <div
                  v-else-if="allData['historical'].length === 0"
                  class="text-center"
                  style="width: 100%; top: calc(50% - 8px)!important; position: absolute;"
                >
                  No data available
                </div>
                <div
                  class="h-100 d-flex flex-column"
                  :id="`curve-analysis-${uniqueId}-div`"
                >
                  <svg :id="`svg-curve-analysis-${uniqueId}`"></svg>
                </div>
              </div>
              <div
                class="col col-7"
                style="height:100%; width:100%; position: relative;"
              >
                <div
                  v-if="loading['curveProcess']"
                  class="text-center"
                  style="width: 100%; top: calc(50% - 8px)!important; position: absolute;"
                >
                  <QSLoading
                    :isLoading="loading['curveProcess']"
                    :size="40"
                    :colorTheme="colorTheme"
                  />
                </div>
                <div
                  v-else-if="allData['futuresCurve'].length === 0"
                  class="text-center"
                  style="width: 100%; top: calc(50% - 8px)!important; position: absolute;"
                >
                  No data available
                </div>
                <div
                  class="h-100 d-flex flex-column"
                  :id="`curve-analysis-future-${uniqueId}-div`"
                >
                  <svg :id="`svg-curve-analysis-future-${uniqueId}`"></svg>
                </div>
              </div>
            </div>
            <!-- Row: table-->
            <div
              class="row f-row curve_analysis_table_height"
              :class="{
                'curve_analysis_table_height--compact': isTableCompact,
              }"
            >
              <div
                class="col col-5"
                style="height:100%; width:100%; position: relative;"
              >
                <div v-if="loading['curveProcess']"></div>
                <div
                  v-else-if="allData['futuresCurve'].length === 0"
                  class="text-center"
                  style="width: 100%; top: calc(50% - 8px)!important; position: absolute;"
                >
                  No data available
                </div>
                <div
                  v-else
                  :style="{
                    'padding-left': formatVars['marginSize'] + 'px',
                  }"
                >
                  <table
                    class="table table-sm table-borderless curve_analysis_table"
                  >
                    <thead class="table-headers text-center align-center thead">
                      <tr v-if="userSelections['showComparison']">
                        <th style="text-align: right!important;">
                          <i class="fa fa-minus" style="color:var(--hedge)"></i>
                          <i class="fa fa-minus" style="color:var(--hedge)"></i>
                          Prices for
                          {{ this.userSelections["selectedDate"] | dateFormat }}
                        </th>
                      </tr>
                      <tr
                        v-for="(dat, idx) in formatVars['tableFormat']"
                        v-bind:key="idx"
                      >
                        <th style="text-align: right!important;">
                          <i
                            class="fa fa-minus"
                            :style="{ color: dat.bdr }"
                          ></i>
                          <i
                            class="fa fa-minus"
                            :style="{ color: dat.bdr }"
                          ></i>
                          {{ dat.label }}
                        </th>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
              <div
                class="col col-7"
                style="height:100%; width:100%; position: relative;"
              >
                <div v-if="loading['curveProcess']"></div>
                <div
                  v-else-if="allData['futuresCurve'].length === 0"
                  class="text-center"
                  style="width: 100%; top: calc(50% - 8px)!important; position: absolute;"
                >
                  No data available
                </div>
                <div
                  :style="{
                    'padding-right': formatVars['marginSize'] + 'px',
                  }"
                >
                  <table
                    class="table table-sm table-borderless curve_analysis_table"
                  >
                    <thead class="table-headers text-center align-center thead">
                      <tr v-if="userSelections['showComparison']">
                        <td
                          v-for="(item, index) in allData['hoveredCurve']"
                          v-bind:key="index"
                          v-bind:class="{
                            tableHovered:
                              (formatVars['userHovered']['date'] === item.id &&
                                formatVars['userHovered']['variable'] ===
                                  'RATEHISTORICAL' &&
                                formatVars['userHovered']['hovered']) ||
                              (formatVars['userHovered']['fromChart'] &&
                                formatVars['userHovered']['date'] === item.id),
                          }"
                          :style="{
                            'background-color': formatVars['hoveredAlpha'](
                              colorTheme,
                            ),
                            'border-bottom':
                              '1px solid ' + formatVars['hovered'](colorTheme),
                          }"
                          @mouseover="
                            onTableHover(
                              { elementName: 'RATEHISTORICAL' },
                              item,
                              true,
                            )
                          "
                          @mouseleave="
                            onTableHover(
                              { elementName: 'RATEHISTORICAL' },
                              item,
                              false,
                            )
                          "
                        >
                          {{ item["hovered"] }}
                        </td>
                      </tr>
                      <tr
                        v-for="(dat, idx) in formatVars['tableFormat']"
                        v-bind:key="idx"
                      >
                        <td
                          v-for="(item, index) in allData['futuresCurve']"
                          v-bind:key="index"
                          v-bind:class="{
                            tableHovered:
                              (formatVars['userHovered']['date'] === item.id &&
                                formatVars['userHovered']['variable'] ===
                                  dat['elementName'] &&
                                formatVars['userHovered']['hovered']) ||
                              (formatVars['userHovered']['fromChart'] &&
                                formatVars['userHovered']['date'] === item.id),
                          }"
                          :style="{
                            'background-color': dat['back'],
                            'border-bottom': '1px solid ' + dat['bdr'],
                          }"
                          @mouseover="onTableHover(dat, item, true)"
                          @mouseleave="onTableHover(dat, item, false)"
                        >
                          <span v-if="dat.doFormat">
                            {{ item[dat.k] | numberFormat }}</span
                          >
                          <span v-else> {{ item[dat.k] }}</span>
                        </td>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { getCommodityCurveAnalysis } from "@/_core/data/api_calls/getCommodityCurveAnalysis";
import {
  candleAlpha,
  colorExpo,
  colorExpoAlpha,
  colorExpoAlpha4,
  colorFwdAlpha2,
  colorFwdF,
  colorHedge,
  colorHedgeAlpha,
  currencyFormat,
  darkFwdF,
  dnCandles,
  grayLightBackground,
  lightbackground2,
} from "@/_core/_helpers/_parametric_tools";
import {
  lengthByDate,
  noLiquidity,
  sortByKey,
} from "@/_core/_helpers/_helpers";
import { D3HoverCurveAnalysis } from "@/_core/charts/D3CurveAnalysis";
import {
  select,
  symbol as symbolD3,
  format,
  timeFormat,
  symbolSquare,
  min,
} from "d3";
import { D3ChartAnimation } from "@/_core/charts/D3ChartAnimations";
import { createXYLastTooltips } from "@/_core/charts/D3Helpers";
import { Chart } from "@/_core/refactor/Chart";
import Calendar from "primevue/calendar";
import IntervalsIndepComponent from "@/components/intervals/IntervalsIndep";
import QSLoading from "@/components/QSLoading.vue";

export default {
  name: "CurveAnalysis",
  components: {
    Calendar,
    IntervalsIndepComponent,
    QSLoading,
  },
  props: {
    colorTheme: { required: true, type: Boolean, default: true },
    commodityDefs: { required: true },
    isSmall: { required: false, type: Boolean, default: false },
    processData: { required: true },
    spot: { required: true },
    verySmall: { required: false, type: Boolean, default: false },
  },
  data() {
    return {
      uniqueId: null,
      allData: {
        curve: [],
        futuresCurve: [],
        highlight: false,
        historical: [],
        historicalSliced: [],
        hoveredCurve: [],
        keys: [],
        keyDate: [],
        minMaxYAxis: [Infinity, -Infinity],
        render: true,
      },
      chartElements: {
        D3Chart: null,
        D3ChartAnimation: null,
        D3ChartCurve: null,
        D3HoverCurveAnalysis: null,
        svgNode: null,
        svgNodeCurve: null,
      },
      formatVars: {
        barHeight: 4,
        current: colorFwdF,
        currentAlpha: colorFwdAlpha2,
        currentTooltip: darkFwdF,
        dateFormat: "%d %b %y",
        dateFormatCurve: "%b %y",
        dnAlpha: candleAlpha,
        dnCandles: dnCandles,
        hovered: colorHedge,
        hoveredAlpha: colorHedgeAlpha,
        hoveredBarWidth: 0.75,
        hoveredY: lightbackground2,
        hoveredLines: grayLightBackground,
        logo: require("@/assets/images/symbol_blue.svg"),
        lineArea: colorExpoAlpha,
        lineWidth: 2,
        marginSize: 60,
        max: colorExpo,
        min: colorExpo,
        rangeFill: colorExpoAlpha4,
        tableFormat: [
          {
            k: "current",
            back: "rgba(0,0,0,0)",
            bdr: "rgba(0,0,0,0)",
            elementName: "...",
            label: "...",
          },
        ],
        upAlpha: candleAlpha,
        upCandles: colorExpo,
        userHovered: {
          date: "",
          variable: "",
          hovered: false,
          fromChart: false,
        },
        vertLine: grayLightBackground,
        yAxisFormat: currencyFormat,
      },
      userSelections: {
        dateInterval: "3M",
        historyInterval: "6M",
        isCandles: null,
        selectedDate: new Date(),
        selectedDateIdx: null,
        showComparison: false,
        prevSelectedDateIdx: null,
      },
      loading: {
        historical: false,
        historicalProcess: false,
        curveProcess: false,
      },
      slotUsed: true,
      resizeObserver: null,
      isTableCompact: false,
      tableResizeObserver: null,
    };
  },
  computed: {
    commodityStringLong() {
      let len = this.allData["historical"].length;
      let str =
        len > 0 &&
        this.allData["historical"][len - 1].contract_month_year != null
          ? " - CURRENTLY " +
            this.allData["historical"][len - 1].contract_month_year
          : "";
      return (
        this.commodityDefs.fk_idproduct.toUpperCase() +
        " - CONTRACT # " +
        this.commodityDefs.selected_contract +
        str +
        " (" +
        (this.commodityDefs.is_cents
          ? "USc"
          : this.commodityDefs.fk_idcurrency) +
        "/" +
        this.commodityDefs.fk_idunit +
        ")"
      );
    },
    loadingHistorical() {
      return this.loading["historical"];
    },
    loadingAll() {
      return (
        this.loading["historical"] ||
        this.loading["historicalProcess"] ||
        this.loading["curveProcess"]
      );
    },
  },
  watch: {
    commodityDefs() {
      this.getAllData();
    },
    loadingAll(val) {
      if (val === false) {
        this.getExistingSelectedDate();
        this.createHovered();
        this.minMax();
        this.createCharts();
      }
    },
    loadingHistorical(val) {
      if (val === false) {
        this.sliceHist();
        this.createCurveData();
      }
    },
    colorTheme() {
      this.createCharts();
    },
    spot() {
      if (
        this.allData.historical.length > 0 &&
        this.allData.futuresCurve.length > 0
      ) {
        this.updateSpotData();
        this.createCharts();
      }
    },
  },
  created() {
    // Generate unique ID for this instance
    this.uniqueId = crypto.randomUUID();

    this.getAllData();
    this.chartElements["D3Chart"] = new Chart(
      `curve-analysis-${this.uniqueId}`,
    );

    this.chartElements["D3ChartAnimation"] = new D3ChartAnimation();
    this.chartElements["D3ChartCurve"] = new Chart(
      `curve-analysis-future-${this.uniqueId}`,
    );

    this.chartElements["D3HoverCurveAnalysis"] = new D3HoverCurveAnalysis(
      `curve-analysis-${this.uniqueId}`,
      `curve-analysis-future-${this.uniqueId}`,
      this.uniqueId,
    );
    this.createTableFormat();
  },
  mounted() {
    let _this = this;
    window.addEventListener("resize", function() {
      _this.createCharts();
    });

    // Add ResizeObserver for container-specific resizes
    this.resizeObserver = new ResizeObserver(() => {
      this.createCharts();
    });
    this.resizeObserver.observe(
      document.getElementById(`curve-analysis-${this.uniqueId}-div`),
    );
    this.resizeObserver.observe(
      document.getElementById(`curve-analysis-future-${this.uniqueId}-div`),
    );
    // ResizeObserver to detect when the table has a size <= 300px
    this.tableResizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        this.isTableCompact = entry.contentRect.height <= 600;
      }
    });
    if (this.$refs.mainContainer) {
      this.tableResizeObserver.observe(this.$refs.mainContainer);
    }

    if (this.$slots.spot) {
      this.slotUsed = true;
    } else {
      this.slotUsed = false;
    }
  },
  beforeDestroy() {
    // Clean up the observer
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.tableResizeObserver) {
      this.tableResizeObserver.disconnect();
    }
  },
  methods: {
    // ==== charts rendering
    createCharts() {
      if (
        this.allData["historical"].length > 0 &&
        this.allData["futuresCurve"].length > 0
      ) {
        this.createHistChart();
        this.createCurveChart();
      } else this.deleteChart();
    },
    updateSpotData() {
      if (this.spot === null || Number.isNaN(this.spot)) {
        return;
      }

      const lastIdx = this.allData.historical.length - 1;
      const lastHist = this.allData.historical[lastIdx];

      lastHist.close = this.spot;
      lastHist.high = Math.max(this.spot, lastHist.high);
      lastHist.low = Math.min(this.spot, lastHist.low);
      const firstKey = this.allData.keys[0];

      if (this.allData.historicalSliced.length) {
        Object.assign(this.allData.historicalSliced.at(-1), {
          [firstKey]: this.spot,
          close: this.spot,
          high: lastHist.high,
          low: lastHist.low,
        });
      }

      if (this.allData.futuresCurve.length) {
        const curr = this.spot;
        const sorted = this.allData.historicalSliced
          .map((dat) => dat[firstKey])
          .filter(
            (dat) => Number.isFinite(dat) && dat !== null && !Number.isNaN(dat),
          )
          .sort((a, b) => a - b);

        const perc = this.processData.percentileNum(sorted, curr);
        const aver = this.processData.average(sorted);
        const q75 = this.processData.percentile(sorted, 0.75);
        const q25 = this.processData.percentile(sorted, 0.25);
        const minMax = this.processData.minMax(
          this.allData.historicalSliced,
          firstKey,
          firstKey,
        );

        Object.assign(this.allData.futuresCurve[0], {
          current: curr,
          perc: (Math.round(1000 * perc) / 10).toString() + "%",
          aver: +aver,
          q75: q75,
          q25: q25,
          min: minMax[0],
          max: minMax[1],
        });
      }
    },
    deleteChart() {
      select(`#curve-analysis-div-${this.uniqueId}`)
        .selectAll(".tooltip")
        .remove();
      select(`#curve-analysis-div-${this.uniqueId}`)
        .select("svg > *")
        .remove();
      select(`#curve-analysis-future-div-${this.uniqueId}`)
        .selectAll(".tooltip")
        .remove();
      select(`#svg-curve-analysis-future-${this.uniqueId}`)
        .select("svg > *")
        .remove();
    },
    createHistChart() {
      if (this.allData["historical"].length === 0) {
        return;
      }
      let _this = this;
      if (this.userSelections["isCandles"] == null) {
        Object.assign(this.userSelections, {
          isCandles: noLiquidity(this.allData["historicalSliced"]),
        });
      }
      // === set SVG canvas
      this.chartElements["D3Chart"].setSVG({
        top: { perc: 0.1, px: 10 },
        right: { perc: 0.5, px: 1 },
        bottom: { perc: 0.5, px: 25 },
        left: { perc: 0.45, px: this.formatVars["marginSize"] },
        logo: this.formatVars["logo"],
        colorTheme: this.colorTheme,
      });
      // === set axis
      this.chartElements["D3Chart"].setAxis({
        xData: this.allData["historicalSliced"],
        minMaxYAxis: this.allData["minMaxYAxis"],
        xFormat: this.formatVars["dateFormat"],
      });
      // === real yAxis range
      let minY = this.chartElements["D3Chart"].svg.yAxis.scale().domain()[0];
      // === horizontal line at spot
      let yPixels = this.chartElements["D3Chart"].svg.y(
        this.allData["historicalSliced"].at(-1).close,
      );
      // ==== zoom setup
      this.chartElements["D3Chart"].enableXZoom(
        `chartBodyHist-${this.uniqueId}`,
        `clipHist-${this.uniqueId}`,
      );

      this.chartElements["D3Chart"]["SelLine"] = this.chartElements[
        "D3Chart"
      ].addLines({
        type: "lineGeneral",
        strokeColor: this.formatVars["current"](this.colorTheme),
        x2: this.chartElements["D3Chart"].svg.width,
        y1: yPixels,
        y2: yPixels,
        strokeOpacity: 0.6,
        className: "",
      });
      // === hovered date diamond
      let isInside =
        +this.userSelections["selectedDate"] >=
        +this.allData["historicalSliced"][0].date;
      let xDel = this.userSelections["isCandles"]
        ? this.chartElements["D3Chart"].svg.x.bandwidth() / 2
        : 0;
      let xPixels = isInside
        ? this.chartElements["D3Chart"].svg.x(
            this.userSelections["selectedDate"],
          ) + xDel
        : 0;
      if (this.userSelections["showComparison"]) {
        // === vertical line at selectedDate
        this.chartElements["D3Chart"]["SelLine"] = this.chartElements[
          "D3Chart"
        ].addLines({
          type: "lineGeneral",
          strokeColor: this.formatVars["hovered"](this.colorTheme),
          x1: xPixels,
          x2: xPixels,
          y2: this.chartElements["D3Chart"].svg.height,
          strokeOpacity: 0.6,
          className: `lineDiamond-${this.uniqueId}`,
        });

        // === diamond selectedDate
        const sym = symbolD3()
          .type(symbolSquare)
          .size(45);
        _this.chartElements["D3Chart"]["Diamond"] = _this.chartElements[
          "D3Chart"
        ].svg
          .append("path")
          .attr("d", sym)
          .attr("fill", _this.formatVars["hovered"](_this.colorTheme))
          .attr("stroke", _this.formatVars["hovered"](_this.colorTheme))
          .attr(
            "transform",
            `translate(${xPixels},${_this.chartElements["D3Chart"].svg.y(
              _this.allData["historical"][
                _this.userSelections["selectedDateIdx"]
              ].high,
            ) - 10}) rotate(45)`,
          );
      }
      // === candles or line
      if (this.userSelections["isCandles"]) {
        this.chartElements["D3Chart"].addCandles({
          type: "candles",
          data: this.allData["historicalSliced"],
          upColor: this.formatVars["upCandles"](this.colorTheme),
          dnColor: this.formatVars["dnCandles"](this.colorTheme),
          customName: "TA",
          opacityUp: this.formatVars["upAlpha"](this.colorTheme),
          opacityDn: this.formatVars["dnAlpha"](this.colorTheme),
          addId: true,
          oldChart: false,
        });
      } else {
        this.allData["historicalSliced"].forEach(function(d) {
          d.zero = minY;
        });
        this.chartElements["D3Chart"].addLines({
          type: "linesArea",
          data: this.allData["historicalSliced"],
          upperLineInfo: {
            color: this.formatVars["upCandles"](this.colorTheme),
            upperName: "close",
            width: 1.5,
            field: "upperLineTA",
          },
          lowerLineInfo: {
            color: "rgba(0,0,0,0)",
            width: 0.5,
            lowerName: "zero",
            field: "lowerLineTA",
          },
          areaColor: this.formatVars["lineArea"](this.colorTheme),
          xIsDate: true,
          fieldArea: "areaTA",
        });
      }
      // === custom hover effects and info
      this.chartElements["D3Chart"] = createXYLastTooltips(
        this,
        this.chartElements["D3Chart"].svg,
        "D3Chart",
        format(this.formatVars["yAxisFormat"]),
        this.allData["historicalSliced"].at(-1).close,
        this.formatVars["marginSize"],
        52,
        this.colorTheme,
        this.formatVars["currentTooltip"](this.colorTheme),
        this.formatVars["hoveredY"](this.colorTheme),
        this.formatVars["hoveredY"](this.colorTheme),
        true,
      );
      this.chartElements["D3HoverCurveAnalysis"].hoverFct(
        this,
        this.chartElements["D3Chart"].svg,
        "D3Chart",
        "TA",
        format(this.formatVars["yAxisFormat"]),
        timeFormat(this.formatVars["dateFormat"]),
        this.colorTheme,
        this.allData["historicalSliced"].at(-1).close,
        this.formatVars["hovered"](this.colorTheme),
        this.formatVars["hoveredY"](this.colorTheme),
        this.formatVars["hoveredY"](this.colorTheme),
        this.formatVars["marginSize"],
        52,
        this.formatVars["hoveredLines"](this.colorTheme),
        true,
        this.userSelections["showComparison"],
        this.uniqueId,
      );
      this.chartElements["svgNode"] = this.chartElements["D3Chart"];
    },
    createCurveChart() {
      if (this.allData["futuresCurve"].length === 0) {
        return;
      }
      // === set SVG canvas
      this.chartElements["D3ChartCurve"].setSVG({
        top: { perc: 0.1, px: 10 },
        right: { perc: 0.5, px: this.formatVars["marginSize"] },
        bottom: { perc: 0.5, px: 25 },
        left: { perc: 0.5, px: 1 },
        logo: this.formatVars["logo"],
        colorTheme: this.colorTheme,
      });

      if (
        this.chartElements["D3ChartCurve"].svg.height === 0 ||
        this.chartElements["D3ChartCurve"].svg.width === 0
      ) {
        return;
      }
      // === set axis
      this.chartElements["D3ChartCurve"].setAxis({
        xData: this.allData["futuresCurve"],
        minMaxYAxis: this.allData["minMaxYAxis"],
        xFormat: this.formatVars["dateFormatCurve"],
        nXTicks: 50,
        yFormat: this.currencyFormat,
        yAxisLeft: false,
      });

      // === vertical line at today
      this.chartElements["D3ChartCurve"].addLines({
        type: "lineGeneral",
        strokeColor: this.formatVars["vertLine"](this.colorTheme),
        x1: this.chartElements["D3ChartCurve"].svg.x(
          this.allData["futuresCurve"][0].date,
        ),
        x2: this.chartElements["D3ChartCurve"].svg.x(
          this.allData["futuresCurve"][0].date,
        ),
        y2: this.chartElements["D3ChartCurve"].svg.height,
        strokeOpacity: 0.3,
        renderShape: "",
        className: "",
      });

      // === horizontal line at spot
      let yPixels = this.chartElements["D3ChartCurve"].svg.y(
        this.allData["historicalSliced"].at(-1).close,
      );
      this.chartElements["D3ChartCurve"]["SelLine"] = this.chartElements[
        "D3ChartCurve"
      ].addLines({
        type: "lineGeneral",
        strokeColor: this.formatVars["current"](this.colorTheme),
        y1: yPixels,
        y2: yPixels,
        lineWidth: 3,
        strokeOpacity: 0.6,
        className: "",
      });
      // === min max range area
      const bandWidth = this.chartElements["D3ChartCurve"].svg.x.bandwidth();
      const candleWidth = (barWidth) =>
        Math.floor(min([bandWidth * barWidth, 1000000]) / 2) * 2 + 1;

      this.chartElements["D3ChartCurve"].addBars({
        type: "gBar",
        data: this.allData["futuresCurve"],
        customName: "RATEES",
        yField: "max",
        fieldColor: "rgba(0,0,0,0)",
        fieldBackground: this.formatVars["rangeFill"](this.colorTheme),
        candleWidth: candleWidth(0.7),
        yLowerField: "min",
        multipleHeight: true,
        toZero: false,
        xIsDate: false,
      });

      // === q75-q25 range area
      this.chartElements["D3ChartCurve"].addBars({
        type: "gBar",
        data: this.allData["futuresCurve"],
        customName: "RATEESS",
        yField: "q75",
        fieldColor: "rgba(0,0,0,0)",
        fieldBackground: this.formatVars["rangeFill"](this.colorTheme),
        candleWidth: candleWidth(0.7),
        yLowerField: "q25",
        multipleHeight: true,
        toZero: false,
        xIsDate: false,
      });
      const barWidth = this.formatVars["hoveredBarWidth"];
      this.chartElements["D3ChartCurve"].addBars({
        type: "gBar",
        data: this.allData["futuresCurve"],
        customName: "RATEAVE",
        yField: "aver",
        lineWidth: 2,
        height: 4,
        fieldColor: this.formatVars["max"](this.colorTheme),
        candleWidth: candleWidth(barWidth),
        toZero: false,
        xIsDate: false,
      });
      // Hovered historical
      if (this.userSelections["showComparison"]) {
        this.chartElements["D3ChartCurve"].addBars({
          type: "gBar",
          data: this.allData["hoveredCurve"],
          customName: "RATEHISTORICAL",
          yField: "hovered",
          lineWidth: 2,
          height: 4,
          fieldColor: this.formatVars["hovered"](this.colorTheme),
          candleWidth: candleWidth(barWidth),
          toZero: false,
          xIsDate: false,
          isMultipleBars: true,
        });
      }
      // ==== creates three bands; min, max and current === //
      this.chartElements["D3ChartCurve"].addBars({
        type: "gBar",
        data: this.allData["futuresCurve"],
        customName: "RATEMAX",
        yField: "max",
        lineWidth: 2,
        height: 4,
        fieldColor: this.formatVars["max"](this.colorTheme),
        candleWidth: candleWidth(barWidth),
        toZero: false,
        xIsDate: false,
      });

      this.chartElements["D3ChartCurve"].addBars({
        type: "gBar",
        data: this.allData["futuresCurve"],
        customName: "RATEMIN",
        yField: "min",
        lineWidth: 2,
        height: 4,
        fieldColor: this.formatVars["min"](this.colorTheme),
        candleWidth: candleWidth(barWidth),
        toZero: false,
        xIsDate: false,
      });

      this.chartElements["D3ChartCurve"].addBars({
        type: "gBar",
        data: this.allData["futuresCurve"],
        customName: "RATECURRENT",
        yField: "current",
        lineWidth: 2,
        height: 4,
        fieldColor: this.formatVars["current"](this.colorTheme),
        candleWidth: candleWidth(0.85),
        toZero: false,
        xIsDate: false,
      });

      // === custom hover effects and info
      this.chartElements["D3ChartCurve"] = createXYLastTooltips(
        this,
        this.chartElements["D3ChartCurve"].svg,
        "D3ChartCurve",
        format(this.formatVars["yAxisFormat"]),
        this.allData["historicalSliced"].at(-1).close,
        this.formatVars["marginSize"],
        52,
        this.colorTheme,
        this.formatVars["currentTooltip"](this.colorTheme),
        this.formatVars["hoveredY"](this.colorTheme),
        this.formatVars["hoveredY"](this.colorTheme),
        false,
      );
      this.chartElements["D3HoverCurveAnalysis"].hoverFct(
        this,
        this.chartElements["D3ChartCurve"].svg,
        "D3ChartCurve",
        "RATES",
        format(this.formatVars["yAxisFormat"]),
        timeFormat(this.formatVars["dateFormatCurve"]),
        this.colorTheme,
        this.allData["historicalSliced"].at(-1).close,
        this.formatVars["current"](this.colorTheme),
        this.formatVars["hoveredY"](this.colorTheme),
        this.formatVars["hoveredY"](this.colorTheme),
        this.formatVars["marginSize"],
        52,
        this.formatVars["hoveredLines"](this.colorTheme),
        false,
        false,
        this.uniqueId,
      );

      this.chartElements["svgNodeCurve"] = this.chartElements["D3ChartCurve"];
    },
    animateDiamond() {
      if (
        +this.userSelections["selectedDate"] >=
        +this.allData["historicalSliced"][0].date
      ) {
        let idx = this.userSelections["prevSelectedDateIdx"];
        let dat = this.allData["historical"][idx].date;
        Object.assign(this.userSelections, {
          selectedDateIdx: idx,
        });
        Object.assign(this.userSelections, {
          selectedDate: dat,
        });
        if (
          +this.userSelections["selectedDate"] >=
          +this.allData["historicalSliced"][0].date
        ) {
          let _this = this;
          let xDel = this.userSelections["isCandles"]
            ? this.chartElements["svgNode"].svg.x.bandwidth() / 2
            : 0;
          // === vertical line at selectedDate
          select(`.lineDiamond-${this.uniqueId}`).join(
            function(enter) {
              return enter
                .append("line")
                .attr("stroke-width", 1)
                .attr("stroke-opacity", 0.6)
                .attr("stroke", _this.formatVars["hovered"](_this.colorTheme))
                .attr(
                  "x1",
                  _this.chartElements["svgNode"].svg.x(
                    _this.userSelections["selectedDate"],
                  ) + xDel,
                )
                .attr("y1", 0)
                .attr(
                  "x2",
                  _this.chartElements["svgNode"].svg.x(
                    _this.userSelections["selectedDate"],
                  ) + xDel,
                )
                .attr("y2", _this.chartElements["svgNode"].svg.height);
            },
            function(update) {
              return update
                .attr(
                  "x1",
                  _this.chartElements["svgNode"].svg.x(
                    _this.userSelections["selectedDate"],
                  ) + xDel,
                )
                .attr(
                  "x2",
                  _this.chartElements["svgNode"].svg.x(
                    _this.userSelections["selectedDate"],
                  ) + xDel,
                );
            },
            function(exit) {
              return exit.remove();
            },
          );
          // === diamond selectedDate
          var sym = symbolD3()
            .type(symbolSquare)
            .size(45);
          this.chartElements["svgNode"]["Diamond"] = this.chartElements[
            "svgNode"
          ]["Diamond"].join(
            function(enter) {
              return enter
                .append("path")
                .attr("d", sym)
                .attr("fill", _this.formatVars["hovered"](_this.colorTheme))
                .attr("stroke", _this.formatVars["hovered"](_this.colorTheme))
                .attr(
                  "transform",
                  `translate(${_this.chartElements["svgNode"].svg.x(
                    _this.userSelections["selectedDate"],
                  ) + xDel},${_this.chartElements["svgNode"].svg.y(
                    _this.allData["historical"][
                      _this.userSelections["selectedDateIdx"]
                    ].high,
                  ) - 10}) rotate(45)`,
                );
            },
            function(update) {
              return update.attr(
                "transform",
                `translate(${_this.chartElements["svgNode"].svg.x(
                  _this.userSelections["selectedDate"],
                ) + xDel},${_this.chartElements["svgNode"].svg.y(
                  _this.allData["historical"][
                    _this.userSelections["selectedDateIdx"]
                  ].close,
                )}) rotate(45)`,
              );
            },
            function(exit) {
              return exit.remove();
            },
          );
        }
      }
    },
    animateCurveChart(d, i) {
      let _this = this;
      const barWidth = this.formatVars["hoveredBarWidth"];
      // == create hovered data
      Object.assign(this.userSelections, {
        selectedDate: d.date,
      });
      Object.assign(this.userSelections, {
        selectedDateIdx:
          this.allData["historical"].length -
          this.allData["historicalSliced"].length +
          i,
      });
      this.createHovered();
      // == animate hovered data
      let yt = this.chartElements["svgNodeCurve"].svg.y;

      this.chartElements["svgNodeCurve"].svg[
        "RATEHISTORICAL"
      ] = this.chartElements["svgNodeCurve"].svg["RATEHISTORICAL"]
        .data(_this.allData["hoveredCurve"], function(dat) {
          return dat;
        })
        .join(
          function(enter) {
            return _this.chartElements["D3ChartAnimation"].barsEnter(
              enter,
              _this.chartElements["svgNodeCurve"].svg,
              "RATEHISTORICAL",
              barWidth,
              _this.formatVars["hovered"](_this.colorTheme),
              "rgba(0,0,0,0)",
              "date",
              "hovered",
              false,
              false,
              _this.formatVars["barHeight"],
              _this.formatVars["lineWidth"],
              true,
            );
          },
          function(update) {
            return update
              .attr("y", (dat) => yt(dat.hovered))
              .style("shape-rendering", "crispEdges");
          },
          function(exit) {
            return exit.remove();
          },
        );
    },
    // ==== user interactions
    onUserShowComparison() {
      let bool = this.userSelections["showComparison"];
      Object.assign(this.userSelections, { showComparison: !bool });
      this.deleteChart();
      this.minMax();
      this.createHistChart();
      this.createCurveChart();
    },
    onTableHover(dat, item, isHovered) {
      const container = select(`#curve-analysis-future-${this.uniqueId}-div`);
      container
        .select(`.bar${dat["elementName"]}${item.id}`)
        .classed("hoved", isHovered);

      container.select(`.bandsRATES${item.id}`).classed("hoved", isHovered);

      Object.assign(this.formatVars, {
        userHovered: {
          date: item.id,
          variable: dat["elementName"],
          hovered: isHovered,
          fromChart: false,
        },
      });
      if (isHovered) {
        this.chartElements["svgNodeCurve"]["xTooltip"]
          .style("opacity", 1)
          .style(
            "left",
            this.chartElements["svgNodeCurve"].svg.x(item.date) +
              this.chartElements["svgNodeCurve"].svg.x.bandwidth() / 2 +
              this.chartElements["svgNodeCurve"].svg.margin.left -
              this.formatVars["marginSize"] / 2 +
              "px",
          )
          .html(timeFormat(this.formatVars["dateFormatCurve"])(item.date));
      } else {
        this.chartElements["svgNodeCurve"]["xTooltip"]
          .style("left", "-1000000px")
          .style("opacity", 0)
          .html("");
      }
    },
    onChangeHistoryInterval(paramInterval) {
      Object.assign(this.userSelections, { historyInterval: paramInterval });
      this.sliceHist();
      this.createCurveData();
      this.minMax();
      this.createHistChart();
      this.createCurveChart();

      this.updateSpotData();
    },
    onChangeDateInterval(val) {
      Object.assign(this.userSelections, { dateInterval: val });
      this.getExistingSelectedDate();
      this.createHovered();
      this.minMax();
      this.createCharts();
    },
    onUserCandlesLineSelect() {
      let bool = !this.userSelections["isCandles"];
      Object.assign(this.userSelections, { isCandles: bool });
      select(`#curve-analysis-${this.uniqueId}-div`)
        .selectAll(".tooltip")
        .remove();
      select(`#curve-analysis-${this.uniqueId}-div`)
        .select("svg > *")
        .remove();
      this.createHistChart();
    },
    onUserSelectedDate() {
      Object.assign(this.userSelections, { dateInterval: "..." });
      let idx = this.processData.closestNum(
        this.allData["historical"].map((d) => +d.date),
        +this.userSelections["selectedDate"],
      );
      Object.assign(this.userSelections, {
        selectedDateIdx: idx,
      });
      Object.assign(this.userSelections, {
        selectedDate: this.allData["historical"][idx].date,
      });
      Object.assign(this.userSelections, {
        prevSelectedDateIdx: idx,
      });
      this.createHovered();
      this.createCharts();
    },
    // ==== data process
    createHovered() {
      Object.assign(this.allData, {
        hoveredCurve: this.allData["curve"][
          +this.userSelections["selectedDate"]
        ],
      });
    },
    createCurveData() {
      let futuresCurve = [],
        minMax = [],
        curr = 0,
        perc = 0,
        sorted,
        aver,
        q75,
        q25,
        nLen = this.allData["historicalSliced"].length - 1,
        _this = this;
      this.allData["keys"].forEach(function(d, i) {
        curr = +_this.allData["historicalSliced"][nLen][d];
        sorted = _this.allData["historicalSliced"]
          .map((dat) => dat[d])
          .filter(
            (dat) => Number.isFinite(dat) && dat !== null && !Number.isNaN(dat),
          )
          .sort(function(a, b) {
            return a - b;
          });
        perc = _this.processData.percentileNum(sorted, curr);
        aver = _this.processData.average(sorted);
        q75 = _this.processData.percentile(sorted, 0.75);
        q25 = _this.processData.percentile(sorted, 0.25);
        minMax = _this.processData.minMax(
          _this.allData["historicalSliced"],
          d,
          d,
        );
        futuresCurve.push({
          date: _this.allData["keyDate"][i],
          id: +_this.allData["keyDate"][i],
          aver: +aver,
          min: minMax[0],
          max: minMax[1],
          q75: q75,
          q25: q25,
          perc: (Math.round(1000 * perc) / 10).toString() + "%",
          current: curr,
        });
      });
      futuresCurve = sortByKey(futuresCurve, "date");
      if (this.isSmall) {
        futuresCurve = futuresCurve.slice(0, 6);
      }

      Object.assign(this.allData, { futuresCurve: futuresCurve });
      Object.assign(this.loading, { curveProcess: false });
    },
    minMax() {
      this.allData["minMaxYAxis"] = [Infinity, -Infinity];
      if (this.allData["historicalSliced"].length > 0) {
        this.allData["minMaxYAxis"] = this.processData.minMax(
          this.allData["historicalSliced"],
          "high",
          "low",
          this.allData["minMaxYAxis"],
        );
      }
      if (this.allData["futuresCurve"].length > 0) {
        this.allData["minMaxYAxis"] = this.processData.minMax(
          this.allData["futuresCurve"],
          "max",
          "min",
          this.allData["minMaxYAxis"],
        );
        this.allData["minMaxYAxis"] = this.processData.minMax(
          this.allData["hoveredCurve"],
          "hovered",
          "hovered",
          this.allData["minMaxYAxis"],
        );
      }
      let del =
        0.02 *
        (this.allData["minMaxYAxis"][1] - this.allData["minMaxYAxis"][0]);
      Object.assign(this.allData, {
        minMaxYAxis: [
          this.allData["minMaxYAxis"][0] - del,
          this.allData["minMaxYAxis"][1] + del,
        ],
      });
    },
    sliceHist() {
      let selectedDays = lengthByDate(
        this.userSelections["historyInterval"],
        this.allData["historical"].map((d) => d.date),
      );
      Object.assign(this.allData, {
        historicalSliced: this.processData.toSlice(
          this.allData["historical"],
          selectedDays,
        ),
      });
      Object.assign(this.loading, { historicalProcess: false });
    },
    getExistingSelectedDate() {
      let selectedDays = lengthByDate(
        this.userSelections["dateInterval"],
        this.allData["historical"].map((d) => d.date),
      );
      let idx = this.allData["historical"].length - selectedDays;
      Object.assign(this.userSelections, {
        selectedDateIdx: idx,
      });
      Object.assign(this.userSelections, {
        selectedDate: this.allData["historical"][idx].date,
      });
      Object.assign(this.userSelections, {
        prevSelectedDateIdx: idx,
      });
    },
    createTableFormat() {
      Object.assign(this.formatVars, {
        tableFormat: [
          {
            back: this.formatVars["currentAlpha"](this.colorTheme),
            bdr: this.formatVars["current"](this.colorTheme),
            doFormat: true,
            elementName: "RATECURRENT",
            k: "current",
            label: "Current Prices",
          },
          {
            back: this.formatVars["currentAlpha"](this.colorTheme),
            bdr: this.formatVars["current"](this.colorTheme),
            doFormat: false,
            elementName: "RATECURRENT",
            k: "perc",
            label: "Current Percentile",
          },
          {
            back: this.formatVars["rangeFill"](this.colorTheme),
            bdr: this.formatVars["max"](this.colorTheme),
            doFormat: true,
            elementName: "RATEAVE",
            k: "aver",
            label: "Average",
          },
          {
            back: this.formatVars["rangeFill"](this.colorTheme),
            bdr: this.formatVars["max"](this.colorTheme),
            doFormat: true,
            elementName: "RATEMAX",
            k: "max",
            label: "Maximum",
          },
          {
            back: this.formatVars["rangeFill"](this.colorTheme),
            bdr: this.formatVars["min"](this.colorTheme),
            doFormat: true,
            elementName: "RATEMIN",
            k: "min",
            label: "Minimum",
          },
        ],
      });
    },
    // ==== endpoints
    getAllData() {
      this.deleteChart();
      let initialDate = new Date(
        new Date().setFullYear(new Date().getFullYear() - 2),
      );
      Object.assign(this.allData, { curve: [] });
      Object.assign(this.allData, { futuresCurve: [] });
      Object.assign(this.allData, { historical: [] });
      Object.assign(this.allData, { historicalSliced: [] });
      Object.assign(this.allData, { hoveredCurve: [] });
      Object.assign(this.allData, { keys: [] });
      Object.assign(this.allData, { keyDate: [] });
      Object.assign(this.allData, { minMaxYAxis: [] });
      getCommodityCurveAnalysis(
        this,
        this.commodityDefs.pk_idcommodity,
        initialDate,
        this.processData,
        "historicalData",
        "showLoadingCurve",
      );
      this.allData["render"] = !this.allData["render"];
    },
  },
  filters: {
    dateFormat: function(val) {
      return val === null ||
        val === "" ||
        val === 0 ||
        +val < +new Date(1980, 1, 1)
        ? "-"
        : timeFormat("%b %d, %y")(val);
    },
    numberFormat: function(val) {
      return val === null || !isFinite(val) || val === 0
        ? "-"
        : Math.abs(val) > 10000
        ? format(",.0f")(val)
        : Math.abs(val) > 100
        ? format(",.2f")(val)
        : Math.abs(val) > 10
        ? format(",.3f")(val)
        : format(",.4f")(val);
    },
    percentageFormat: function(val) {
      return format(",.1")(val / 100);
    },
  },
};
</script>

<style scoped>
.toggle__button_g .toggle__switch_g::after,
.toggle__button_g .toggle__switch_g::before {
  content: "";
}
.controls div.col.col-5 > div {
  align-items: center;
}
@media (max-width: 1229px) {
  .controls {
    max-height: 3rem;
  }
  .controls_date-r {
    max-width: 6rem !important;
    flex: 1 !important;
  }
  div .controls_intervals {
    max-width: 10rem !important;
  }
  .controls_calendar {
    max-width: 80px;
  }
  .markets-chart-title {
    font-size: 0.75rem !important;
  }
  .curve_analysis_table td,
  .curve_analysis_table th,
  .curve_line {
    font-size: 0.7rem !important;
  }
}

.curve_analysis_table_height--compact {
  max-height: 70px;
  height: 100% !important;
  overflow-y: scroll;
}

@media ((min-width: 1230px) and (max-width: 1500px)) {
  .controls {
    max-height: 3.5rem !important;
  }
  .controls_calendar {
    max-width: 15%;
  }
}
@media ((min-width: 1200px) and (max-width: 1400px)) {
  .curve_analysis_table td,
  .curve_analysis_table th,
  .curve_line {
    font-size: 0.8rem !important;
  }
  .controls_intervals {
    max-width: 28% !important;
  }
  .controls_date-r {
    max-width: 8rem !important;
    flex: 1 !important;
  }
}
@media ((min-width: 1300px) and (max-width: 1416px)) {
  .controls_intervals {
    max-width: 32% !important;
  }
}

.left_padd {
  padding-left: 5px !important;
}
</style>
